export default __webpack_public_path__ + "static/media/Fetch_pals.3ab551f1.jpg";